import { render } from "./feedbacklistInfo.vue?vue&type=template&id=2f22a75e&scoped=true"
import script from "./feedbacklistInfo.vue?vue&type=script&lang=js"
export * from "./feedbacklistInfo.vue?vue&type=script&lang=js"

import "./feedbacklistInfo.vue?vue&type=style&index=0&id=2f22a75e&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f22a75e"]])

export default __exports__